import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import IllustrationCategory from '../../../domain/entities/IllustrationCategory';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexIllustrationCategoriesSuccess: {
      const result = action.payload as PaginatedResult<IllustrationCategory>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
